import * as Yup from "yup";

export const financialValidationSchema = Yup.object().shape({
  organization: Yup.object().shape({
    fiscalCode: Yup.string().required("Required"),
  }),
  cup: Yup.string().required("Required"),
  coFinancing: Yup.number().required("Required"),
});

export const organizationValidationSchema = Yup.object().shape({
  organization: Yup.object().shape({
    fiscalCode: Yup.string().required("Required"),
    description: Yup.string().required("Required"),
    longDescription: Yup.string().required("Required"),
    legalRepresentativeName: Yup.string().required("Required"),
  }),
});
